export default function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap">密桃视频</span>
            </div>
            <p className="text-xs leading-relaxed text-background-50/50">
              汇聚91视频、91视频网站、久久视频等热门资源，免费高清全集在线观看。91在线视频每日更新最新电影电视剧，追剧首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门排行', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '精选推荐', href: '#cards' },
                { label: '精彩视频', href: '#media' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">更多内容</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '专题合集', href: '#index' },
                { label: '常见问题', href: '#faq' },
                { label: '用户评价', href: '#comments' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">平台特色</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '平台优势', href: '#features' },
                { label: '焦点专题', href: '#carousel' },
                { label: '联系我们', href: '#contact' },
                { label: '移动观影', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="text-sm font-semibold text-background-50 mb-3">友情链接</h4>
            <div className="flex flex-col gap-2">
              {['91视频', '91视频网站', '久久视频', '91在线视频'].map((name) => (
                <span key={name} className="text-xs text-background-50/40 whitespace-nowrap">{name}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40 text-center md:text-left">
              &copy; 2026 密桃视频 mitaovideo.com. 本站内容仅供学习交流，请支持正版影视作品。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">回到顶部</a>
              <a href="#faq" onClick={(e) => scrollToSection(e, '#faq')} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}